import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARAdvanceReceiveActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Advance/AdvanceBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceARAdvanceReceive"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARAdvanceReceive"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARAdvanceReceiveActivity)
